import Vue from 'vue'
import App from '@/models/App'
import Ship from '@/models/Ship'
import Organization from '@/models/Organization'

export default class ShipSpare extends App {
    static get entity() {
        return 'ShipSpares'
    }
    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }
    static all() {
        return this.query()
            .withAllRecursive()
            .orderBy('$isNew', 'desc')
            .orderBy('id', 'desc')
            .get()
    }
    static add() {
        let _this = new Vue()
        this.insert({
            data: {
                organizationId: '',
                shipId: '',
                type: '',
                name: '',
                impa: '',
                price: 0,
                stock: 0,
                comment: '',
                updatedAt: _this.$dayjs().format(),
                $isNew: true,
            },
        })
    }
    static reset(id) {
        this.update({
            where: id,
            data: {
                $isNew: false,
                $isDirty: false,
            },
        })
    }
    static new(id) {
        this.update({
            where: id,
            data: {
                $isNew: true,
                $isDirty: false,
            },
        })
    }
    static dirty(id) {
        this.update({
            where: id,
            data: {
                $isNew: false,
                $isDirty: true,
            },
        })
    }
    static fields() {
        return {
            id: this.uid(),
            organizationId: this.attr(''),
            shipId: this.attr(''),
            type: this.attr(''),
            name: this.attr(''),
            type: this.attr(''),
            impa: this.attr(''),
            price: this.attr(0),
            stock: this.attr(0),
            comment: this.attr(''),
            updatedAt: this.attr(''),
            organization: this.belongsTo(Organization, 'organizationId'),
            ship: this.belongsTo(Ship, 'shipId'),
            $isNew: this.attr(false),
            $isDirty: this.attr(false),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipId, params) {
                return this.get(`${shipId}/spares`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            create(shipId, params) {
                return this.post(`${shipId}/spares`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'spare',
                    baseURL: App.apiURL(),
                })
            },
            comment(shipId, spareId, params) {
                return this.patch(
                    `${shipId}/spares/${spareId}/comment`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'spare',
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(shipId, spareId, params) {
                return this.patch(
                    `${shipId}/spares/${spareId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'spare',
                        baseURL: App.apiURL(),
                    }
                )
            },
            import(shipId, params) {
                return this.post(`${shipId}/spares/import`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            destroy(shipId, spareId) {
                return this.delete(`${shipId}/spares/${spareId}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    delete: spareId,
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
